import { render, staticRenderFns } from "./LiveChatAgent.vue?vue&type=template&id=87649604"
import script from "./LiveChatAgent.vue?vue&type=script&lang=js"
export * from "./LiveChatAgent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports